import { FC } from 'react';
import { AttributeSearch } from '../';
import { SearchContainerProps, SearchValue } from './types/propsTypes';
import styles from './SearchContainer.module.scss';

const SearchContainer: FC<SearchContainerProps> = ({
  data,
  onSearch,
  response,
  searchByStrip = true,
  defaultSearchOptions =  null,
  onReset,
  hideAddButton = false,
}): JSX.Element => (
  <div className={styles['cpw-bo-search-container']}>
    <AttributeSearch
      data={data}
      onSearch={onSearch}
      searchByStrip={searchByStrip}
      defaultSearchOptions = {defaultSearchOptions}
      response={response}
      onReset={onReset}
      hideAddButton={hideAddButton}
    />
  </div>
);

export default SearchContainer;
export type { SearchContainerProps, SearchValue };
